export default __webpack_public_path__ + "static/media/synthefi.da70d922.webp";